import React from 'react';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import BusinessInvoicesPageData from 'Models/Content/BusinessInvoicesPageData';
import {BuisnessInvoicesProvider} from './BusinessInvoicesContext';
import BusinessInvoicesHeader from './BusinessInvoicesHeader';

export default class BusinessInvoicesPage extends Page<BusinessInvoicesPageData> {
  render() {
    const {
      data: {mainContentArea, title, subtitle, faqItems},
      context,
    } = this.props;

    return (
      <div className='BusinessInvoicesPage'>
        <BuisnessInvoicesProvider>
          <BusinessInvoicesHeader title={title.value} subtitle={subtitle.value} faq={<ContentArea data={faqItems} context={context} />} />
          <ContentArea data={mainContentArea} context={context} />
        </BuisnessInvoicesProvider>
      </div>
    );
  }
}
